import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航">
      <ol className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-600">
        {items.map((item, i) => (
          <li key={item.label} className="flex items-center gap-1.5">
            {i > 0 && <i className="ri-arrow-right-s-line text-foreground-400" />}
            {item.to ? (
              <Link to={item.to} className="whitespace-nowrap transition-colors hover:text-primary-600">
                {item.label}
              </Link>
            ) : (
              <span className="whitespace-nowrap text-foreground-400">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}